module.exports = __webpack_public_path__ + "img/spinach-cheese-balls.897a6bcb.jpg";